import type {
  HotelOfferRequestCreateApi,
  HotelRoomOfferRequestCreateApi,
} from '@revolugo/booking-api-client'

export const HOTEL_OFFER_REQUEST_QUERY_KEYS: (keyof HotelOfferRequestCreateApi)[] =
  [
    'address',
    'adultCount',
    'children',
    'roomCount',
    'sourceMarket',
    'checkInDate',
    'checkOutDate',
    'sourceMarket',
  ]

export const HOTEL_ROOM_OFFER_REQUEST_QUERY_KEYS: (keyof HotelRoomOfferRequestCreateApi)[] =
  [
    'adultCount',
    'children',
    'roomCount',
    'sourceMarket',
    'checkInDate',
    'checkOutDate',
    'sourceMarket',
  ]
